import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserDetails } from '../../models/userDetails';
import axios, { AxiosRequestConfig } from 'axios';
import { getToken, getUserDetails } from '../../utilities/sessionHelper';
import { composeParamsString } from '../../utilities/CommonHelper';

interface PurchaseOrder {
    createdBy: string;
    createdDate: string;
    lastModifiedBy: string;
    lastModifiedDate: string;
    id: number;
    poStartDate: string;
    poEndDate: string;
    poNumber: string;
    indegeneEntity: string;
    clientEntity: string;
    currency: string;
    country: string;
    totalPOValue: number;
    mappedValue: number;
    poDescription: string;
    clientContact: string;
    filePath: string;
    shippingAddress: string;
    billingAddress: string;
    deliveryAddress: string;
    poStatus: string;
  }
  
  interface PoResponse {
    data: PurchaseOrder[] | null;
    error: null | string;
    loading: boolean;
    addUpdateModal:{
      openModal:boolean;
    }
  }

  const initialState: PoResponse = {
    data: null,
    error: null,
    loading: false,  
    addUpdateModal:{
      openModal:false
    
    }
};

export const fetchPoData:any = createAsyncThunk(
  'po/fetchPoData',
  async (params:{
    startDatePOD?: string;
    endDatePOD?: string;
    fullyUtilize?: boolean;
    filterBy?: string;
    page?: number;
    size?: number;
    sort?: string[];
  },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          'loggedInUser': getUserDetails()?.email
          // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call, replace with your actual API request
      const response = await axios.get(`podetails/api/po?startDatePOD=${params.startDatePOD}&endDatePOD=${params.endDatePOD}&fullyUtilize=${params.fullyUtilize}&filterby=${params.filterBy}&${paramStrings}`,axiosConfig);
      console.log('po/fetchPoData',response);
       
      if (response.status!==200) {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchMappedWorkOrders:any = createAsyncThunk(
  'po/fetchMappedWorkOrders',
  async (params:{
    poNumber?: string;
  },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          'loggedInUser': getUserDetails()?.email
          // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      // Simulate an API call, replace with your actual API request
      const response = await axios.get(`podetails/api/poWorkOrderMapping/getMappedWorkordersForPo?poNumber=${params.poNumber}`,axiosConfig);
      console.log('po/fetchMappedWorkOrders',response);
       
      if (response.status!==200) {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getDownloadFile:any = createAsyncThunk(
  'po/getDownloadFile',
  async (params:{
    payload?: string;
  },{rejectWithValue}) => {
    try {
        const axiosConfig : AxiosRequestConfig<any> = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'responseType': 'blob',
          'loggedInUser': getUserDetails()?.email
          // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true,
        responseType: 'blob',
      };
      // Simulate an API call, replace with your actual API request
      const response = await axios.get(`podetails/api/po/download/poFile?key=${params.payload}`,axiosConfig);
      console.log('po/getDownloadFile',response);
      if (response.status !== 200) {
        const errorData = await response.data.error
        return  rejectWithValue("Something went wrong. Please try again later.");
      }
      const userData = await response;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchPaymentTermsList:any = createAsyncThunk(
  'po/fetchPaymentTermsList',
  async (_,{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          'loggedInUser': getUserDetails()?.email
          // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      // Simulate an API call, replace with your actual API request
      const response = await axios.get(`podetails/api/paymentterms`,axiosConfig);
      console.log('po/fetchPaymentTermsList',response);
       
      if (response.status!==200) {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchPoHistory:any = createAsyncThunk(
  'po/fetchPoHistory',
  async (params:{
    poNumber?: string;
  },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          'loggedInUser': getUserDetails()?.email
          // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      // Simulate an API call, replace with your actual API request
      const response = await axios.get(`podetails/api/pohistory?poNumber=${params.poNumber}`,axiosConfig);
      console.log('po/fetchPoHistory',response);
       
      if (response.status!==200) {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const addAndUpdatePO:any = createAsyncThunk(
  'po/addAndUpdatePO',
  async (params:{
    values:any;
  },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          'loggedInUser': getUserDetails()?.email
            // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      // let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call, replace with your actual API request
      const response = await axios.post(`/podetails/api/po`,params.values,axiosConfig);
      console.log('po/addAndUpdatePO',response);
      if (response.data.status !== 'OK') {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const updatePOStatus:any = createAsyncThunk(
  'po/updatePOStatus',
  async (params:{
    poStatus:any;
    poNumber:any;
  },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          'loggedInUser': getUserDetails()?.email
            // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      // let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call, replace with your actual API request
      const response = await axios.post(`/podetails/api/po/updatePoStatus`,params,axiosConfig);
      console.log('po/updatePOStatus',response);
      if (response.data.status !== 'OK') {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getPOReportDownloaded:any = createAsyncThunk(
  'po/getPOReportDownloaded',
  async (params:{
    startDatePOD?: string;
    endDatePOD?: string;
    fullyUtilize?: boolean;
    filterBy?: string;
    page?: number;
    size?: number;
    sort?: string[];
  },{rejectWithValue}) => {
    try {
        const axiosConfig: AxiosRequestConfig<any> = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'loggedInUser': getUserDetails()?.email
        },
        withCredentials: true,
        responseType: 'blob',
      };
      // Simulate an API call, replace with your actual API request
      const response = await axios.get(`podetails/api/po/downloadPoDetails?startDatePOD=${params.startDatePOD}&endDatePOD=${params.endDatePOD}&fullyUtilize=${params.fullyUtilize}&filterby=${params.filterBy}`,axiosConfig);
      console.log('po/getPOReportDownloaded',response);
      if (response.status !== 200) {
        const errorData = await response.data.error
        return  rejectWithValue("Something went wrong. Please try again later.");
      }
      const userData = await response;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const bulkPOValidate:any = createAsyncThunk(
  'po/bulkPOValidate',
  async (params:{
    values:any;
  },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'multipart/form-data',
          'loggedInUser': getUserDetails()?.email
            // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      // let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call, replace with your actual API request
      const formData = new FormData();
      formData.append("file", params.values);
      const response = await axios.post(`/podetails/api/po/upload`,formData,axiosConfig);
      console.log('po/bulkPOValidate',response);
      if (response.data.status !== 'OK') {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const bulkPOUpload:any = createAsyncThunk(
  'po/bulkPOUpload',
  async (params:{
    values:any;
  },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          'loggedInUser': getUserDetails()?.email
            // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      // let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call, replace with your actual API request
      const response = await axios.post(`/podetails/api/po/bulkSave`,params.values,axiosConfig);
      console.log('po/bulkPOUpload',response);
      if (response.data.status !== 'OK') {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
const poDashboardSlice:any = createSlice({
  name: 'po',
  initialState,
  reducers: {
    SetAddUpdateModalStatus: (state, action: PayloadAction<PoResponse['addUpdateModal']>) => {
      state.addUpdateModal.openModal = action.payload.openModal;
    },
    // fetchRmPendingRequest_Request: (state) => {
    //   state.loading = true;
    //   state.error = null;
    // },
    // fetchRmPendingRequest_Success: (state, action: PayloadAction<PoResponse['data']>) => {
         
    //   state.data = action.payload;
    //   state.loading = false;
    //   state.error = null;
    // },
    // fetchRmPendingRequest_Failure: (state, action: PayloadAction<string>) => {
    //   state.loading = false;
    //   state.error = action.payload;
    // },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPoData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPoData.fulfilled, (state, action) => {
         
        state.data = action.payload.content;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchPoData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(addAndUpdatePO.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addAndUpdatePO.fulfilled, (state, action) => {
        // state.requestResponse = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(addAndUpdatePO.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchPaymentTermsList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPaymentTermsList.fulfilled, (state, action) => {
        // state.requestResponse = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchPaymentTermsList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchMappedWorkOrders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMappedWorkOrders.fulfilled, (state, action) => {
        // state.requestResponse = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchMappedWorkOrders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(getDownloadFile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDownloadFile.fulfilled, (state, action) => {
        // state.requestResponse = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(getDownloadFile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchPoHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPoHistory.fulfilled, (state, action) => {
        // state.requestResponse = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchPoHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(getPOReportDownloaded.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPOReportDownloaded.fulfilled, (state, action) => {
        // state.requestResponse = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(getPOReportDownloaded.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(updatePOStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatePOStatus.fulfilled, (state, action) => {
        // state.requestResponse = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(updatePOStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(bulkPOValidate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(bulkPOValidate.fulfilled, (state, action) => {
        // state.requestResponse = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(bulkPOValidate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(bulkPOUpload.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(bulkPOUpload.fulfilled, (state, action) => {
        // state.requestResponse = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(bulkPOUpload.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  }
});

export const {SetAddUpdateModalStatus, fetchRmPendingRequest_Success, fetchRmPendingRequest_Failure } = poDashboardSlice.actions;

export default poDashboardSlice.reducer;